export const TEMPORAL_DATA_FROM_QUOTE_KEY = 'temporal-quote-key'
export const HC_STORAGE_KEY = 'hc'
